/* globals _ */

import api from './api';

const { noop } = _;

export function save( data, callback ) {
	callback = callback || noop;

	api( 'innoway/v2/save_trip', data, response => {
		callback( response );
	}, 'POST' );
}

export function load( userId, callback ) {
	callback = callback || noop;

	api( 'innoway/v2/load_trip', { userId }, response => {
		callback( response );
	}, 'POST' );
}
